<template>
    <div v-if="model">
        <rkm-form ref="RkmForm">
            <rkm-tabs>
                <rkm-tab title="Pós-consulta">
                    <BoxAntropometria
                        :data="{form: form.posConsulta, model: model.posConsulta}"
                        @alturaChange="handleAlturaChange"
                        @circunferenciaAbdominalChange="handleCircunferenciaAbdominalChange"
                        @perimetroCefalicoChange="handlePerimetroCefalicoChange"
                        @perimetroPanturrilhaChange="handlePerimetroPanturrilhaChange"
                        @pesoChange="handlePesoChange"
                    />

                    <BoxSinalVital
                        :data="{model: model.posConsulta}"
                        @pressaoArterialChange="handlePressaoArterialChange"
                        @temperaturaChange="handleTemperaturaChange"
                    />

                    <BoxGlicemiaCapilar
                        :data="{form: form.posConsulta, model: model.posConsulta}"
                        @glicemiaCapilarChange="handleGlicemiaCapilarChange"
                    />

                    <BoxTesteRapido
                        :data="{form, model}"
                        @testeRapidoChange="handleTesteRapidoChange"
                    />

                    <BoxAdministracaoMedicamento
                        :data="{form, model}"
                        @administracaoMedicamentoChange="handleAdministracaoMedicamentoChange"
                    />

                    <BoxOutroProcedimento
                        :data="{form, model}"
                        @outroProcedimentoChange="handleOutroProcedimentoChange"
                    />

                    <BoxColetaMaterial
                        :data="{form, model}"
                        @coletaMaterialChange="handleColetaMaterialChange"
                    />

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-checkbox
                            class="mt-2"
                            v-model="model.posConsulta.orientacaoIndividualEmSaude"
                            >
                                Orientação individual em saúde
                            </rkm-form-checkbox>
                        </rkm-col>
                    </rkm-row>

                    <BoxProcedimento :data="{form: form, model: model.posConsulta}" />

                    <BoxObservacao :data="{model: model.posConsulta}" />

                    <rkm-row>
                        <rkm-col cols="12">
                            <rkm-form-select
                                :options="form.posConsulta.equipes"
                                :validations="validations.equipe"
                                label="Equipe"
                                show-default-option
                                text-field="descricao"
                                v-model="model.posConsulta.equipeId"
                                value-field="id"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="6">
                            <rkm-form-select
                                :options="form.posConsulta.turnos"
                                :validations="validations.turno"
                                label="Turno"
                                text-field="nome"
                                v-model="model.posConsulta.turnoId"
                                value-field="id"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <rkm-form-select
                                :options="form.posConsulta.locaisAtendimento"
                                :validations="validations.atencaoBasicaLocalAtendimento"
                                label="Local de atendimento"
                                text-field="descricao"
                                v-model="model.posConsulta.atencaoBasicaLocalAtendimentoId"
                                value-field="id"
                            />
                        </rkm-col>
                    </rkm-row>

                    <BoxDesfecho
                        :data="{additionals, form: form.posConsulta, model: model.posConsulta}"
                        :fila-id="filaId"
                    />
                </rkm-tab>

                <rkm-tab title="Histórico" v-if="hasPermissao('show-ambulatorio-historico-atendimento')">
                    <BoxHistorico :data="{form}" />
                </rkm-tab>
            </rkm-tabs>
        </rkm-form>

        <rkm-area
            title="Profissional realizando o atendimento"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col>
                    <strong>Profissional: </strong> {{ autenticacao.usuario.cidadao.nome }}
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <strong>CBO: </strong> {{ autenticacao.lotacao.ocupacao.codigo }} - {{ autenticacao.lotacao.ocupacao.nome }}
                </rkm-col>
            </rkm-row>

            <rkm-row v-if="autenticacao.usuario.registroTipo && autenticacao.usuario.registroNumero">
                <rkm-col>
                    <strong>{{ autenticacao.usuario.registroTipoId == enums.tipoRegistro.OUTRO
                        ? autenticacao.usuario.registroTipoOutro
                        : autenticacao.usuario.registroTipo.sigla }}: </strong> {{ autenticacao.usuario.registroNumero }}
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <strong>Data do atendimento: </strong> {{ additionals.dataAtual }} {{ additionals.horaInicioAtendimento }}
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-fab-area>
            <rkm-fab>
                <rkm-fab-item
                    @click="$refs.ModalSolicitacao.open()"
                    icon="search"
                    label="Visualizar solicitações"
                />
            </rkm-fab>
        </rkm-fab-area>

        <ModalImpressao
            @closed="closedModalImpressao"
            ref="ModalImpressao"
        />

        <ModalSolicitacao
            :data="{additionals: additionals, form: form.soap.plano}"
            ref="ModalSolicitacao"
        />
    </div>
</template>

<script>
// Components.
import BoxAdministracaoMedicamento from './components/administracao-medicamento/Form'
import BoxAntropometria from '@/components/ambulatorio/components/antropometria/Index'
import BoxColetaMaterial from './components/coleta-material/Form'
import BoxDesfecho from './components/desfecho/Form'
import BoxGlicemiaCapilar from '@/components/ambulatorio/components/glicemia-capilar/Index'
import BoxHistorico from '@/components/ambulatorio/atendimento/components/historico/Index'
import BoxObservacao from './components/observacao/Form'
import BoxOutroProcedimento from './components/outro-procedimento/Form'
import BoxProcedimento from './components/procedimento/Index'
import BoxSinalVital from '@/components/ambulatorio/components/sinal-vital/Index'
import BoxTesteRapido from './components/teste-rapido/Form'
import ModalImpressao from '@/components/ambulatorio/components/impressao/Modal'
import ModalSolicitacao from './components/soap/components/plano/components/solicitacao/Modal'

// Enums.
import procedimento from '@/enums/sigtap/procedimento'
import tipoRegistro from '@/enums/cadastro/usuario/tipoRegistro'

// Mixins.
import {error, file, permissao, repository, stringCase, unmask} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    components: {
        BoxAdministracaoMedicamento,
        BoxAntropometria,
        BoxColetaMaterial,
        BoxDesfecho,
        BoxGlicemiaCapilar,
        BoxHistorico,
        BoxObservacao,
        BoxOutroProcedimento,
        BoxProcedimento,
        BoxSinalVital,
        BoxTesteRapido,
        ModalImpressao,
        ModalSolicitacao,
    },
    computed: {
        ...mapGetters({
            autenticacao: 'getAutenticacao',
            centroCusto: 'getCentroCusto',
            lotacao: 'getLotacao',
        }),
        validations() {
            return {
                equipe: {required: this.additionals.criaFichaAtencaoBasica && this.form.posConsulta.equipes.length > 0},
                turno: {required: !!this.model.posConsulta.equipeId},
                atencaoBasicaLocalAtendimento: {required: !!this.model.posConsulta.equipeId},
            }
        },
    },
    created() {
        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.ambulatorio'),
            atendimentoEnfermagem: this.getConectaSusRepository('ambulatorio.atendimentoEnfermagem'),
            procedimento: this.getConectaSusRepository('sigtap.procedimento'),
        }
    },
    data: () => ({
        additionals: null,
        enums: {
            procedimento,
            tipoRegistro,
        },
        form: null,
        model: null,
        others: {moment},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        hasPermissao(hash) {
            return this.verificarPermissao(hash);
        },
        load() {
            this.create()
        },
        create() {
            this.setLoading()

            this.repositories.atendimentoEnfermagem.create({funcionalidade: 'pos-consulta', fila_id: this.filaId})
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)

                    this.$emit('loaded', {form: this.form})
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        store() {

            let request = {
                funcionalidade: 'pos-consulta',
                filaId: this.filaId,
                orientacaoIndividualEmSaude: this.model.posConsulta.orientacaoIndividualEmSaude,
                procedimentos: this.model.posConsulta.procedimentos.map(procedimento => {
                    return {
                        procedimentoId: procedimento.id,
                        automatico: procedimento.automatico,
                        quantidade: procedimento.quantidade,
                        materiais: procedimento.materiais ? procedimento.materiais.map(m => ({
                            materialId: m.id,
                            materialQuantidade: m.quantidade,
                            materialEscolheuEntradaItemManualmente: m.materialEscolheuEntradaItemManualmente,
                            materialEntradaItens: m.materialEntradaItens
                                ? m.materialEntradaItens.filter(i => i.quantidadeSaida > 0)
                                : [],
                        }))
                        : [],
                        localCurativo: procedimento.localCurativo,
                    }
                }),
                desfecho: {
                    finalizado: this.model.posConsulta.desfecho.finalizado === 'encaminhar'
                        ? false
                        : this.model.posConsulta.desfecho.finalizado,
                    servicos: this.model.posConsulta.desfecho.servicos,
                    prioridadeId: this.model.posConsulta.desfecho.prioridadeId,
                    opcaoEntradaEncaminhamentoId: this.model.posConsulta.desfecho.finalizado === 'encaminhar'
                        ? this.model.posConsulta.desfecho.opcaoEntradaEncaminhamentoId
                        : null,
                },
                paciente: {
                    telefonePrincipal: {
                        id: this.form.paciente.telefoneId,
                        numero: this.form.paciente.telefoneNumero ? this.unMaskPhone(this.form.paciente.telefoneNumero) : null,
                        autorizaSms: this.form.paciente.telefoneAutorizaSms,
                    },
                },
                testesRapidos: this.model.posConsulta.testesRapidos,
                administracoesMedicamentos: this.model.posConsulta.administracoesMedicamentos,
                outrosProcedimentos: this.model.posConsulta.outrosProcedimentos,
                coletasMateriais: this.model.posConsulta.coletasMateriais,
                observacoes: this.model.posConsulta.observacoes,
                equipeId: this.model.posConsulta.equipeId,
                turnoId: this.model.posConsulta.turnoId,
                atencaoBasicaLocalAtendimentoId: this.model.posConsulta.atencaoBasicaLocalAtendimentoId,
                antropometria: {
                    altura: this.model.posConsulta.antropometria.altura,
                    circunferenciaAbdominal: this.model.posConsulta.antropometria.circunferenciaAbdominal,
                    imc: {
                        classificacao: this.model.posConsulta.antropometria.imc.classificacao,
                        grauObesidade: this.model.posConsulta.antropometria.imc.grauObesidade,
                        imc: this.model.posConsulta.antropometria.imc.imc,
                    },
                    perimetroCefalico: this.model.posConsulta.antropometria.perimetroCefalico,
                    perimetroPanturrilha: this.model.posConsulta.antropometria.perimetroPanturrilha,
                    peso: this.model.posConsulta.antropometria.peso,
                },
                sinalVital: {
                    frequenciaCardiaca: this.model.posConsulta.sinalVital.frequenciaCardiaca,
                    frequenciaRespiratoria: this.model.posConsulta.sinalVital.frequenciaRespiratoria,
                    pressaoArterial: this.model.posConsulta.sinalVital.pressaoArterial,
                    saturacaoO2: this.model.posConsulta.sinalVital.saturacaoO2,
                    temperatura: this.model.posConsulta.sinalVital.temperatura,
                },
                glicemiaCapilar: {
                    valor: this.model.posConsulta.glicemiaCapilar.valor,
                    momentoColetaId: this.model.posConsulta.glicemiaCapilar.momentoColetaId,
                },
            }

            if (this.additionals.isDemandaEspontanea) {
                request.desfecho.ocupacaoId = this.model.posConsulta.desfecho.ocupacaoId
                request.desfecho.especialidadeId = this.model.posConsulta.desfecho.especialidadeId
                request.desfecho.usuarioId = this.model.posConsulta.desfecho.usuarioId
            }


            const executeStore = () => {
                this.setLoading();
                this.repositories.atendimentoEnfermagem.store(this.camelObjectKeysToSnakeRecursive(request))
                    .then(response => {
                        this.openModalImpressao(response.data.atendimentoId);
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading());
            };

            const isProcedimentosVazio = !request.procedimentos || request.procedimentos.length === 0;

                if (isProcedimentosVazio && this.additionals.criaFichaAtencaoBasica) {
                    this.showConfirmation(
                        'Nenhum procedimento foi adicionado, a ficha da atenção básica não será criada. Deseja realmente continuar?',
                        () => this.$nextTick().then(() => executeStore()),
                        null
                    );
                } else {
                    executeStore();
                }
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    const hasProcedimentoComInstrumentoRegistroRaas = this.model.posConsulta.procedimentos.some(procedimento => !!procedimento.hasInstrumentoRegistroRaas)

                    if (!!this.additionals.faturaProcedimentoRaas && hasProcedimentoComInstrumentoRegistroRaas) {
                        this.checkCamposInvalidosParaFaturarProcedimentoRaas()
                    } else {
                        this.store()
                    }
                })
        },
        openModalImpressao(atendimentoId) {
            this.$refs.ModalImpressao.open('pos-consulta', atendimentoId)
        },
        closedModalImpressao() {
            this.showSaveNotification()
            this.$emit('saved')
        },
        handleAdministracaoMedicamentoChange(value) {
            if (value.checked) {
                if (!this.hasProcedimento(value.codigo)) {
                    this.insertProcedimento(value.codigo)
                }
            } else {
                this.deleteProcedimento(value.codigo)
            }
        },
        handleOutroProcedimentoChange(value) {
            if (value.checked) {
                if (!this.hasProcedimento(value.codigo)) {
                    this.insertProcedimento(value.codigo)
                }
            } else {
                this.deleteProcedimento(value.codigo)
            }
        },
        handleColetaMaterialChange(value) {
            if (value.checked) {
                if (!this.hasProcedimento(value.codigo)) {
                    this.insertProcedimento(value.codigo)
                }
            } else {
                this.deleteProcedimento(value.codigo)
            }
        },
        handleTesteRapidoChange(value) {
            if (value.checked) {
                if (!this.hasProcedimento(value.codigo)) {
                    this.insertProcedimento(value.codigo)
                }
            } else {
                this.deleteProcedimento(value.codigo)
            }
        },
        hasProcedimentoAntropometria() {
            return this.model.posConsulta.procedimentos.filter(procedimento => procedimento.codigo === this.enums.procedimento.AVALIACAO_ANTROPOMETRICA).length > 0
        },
        hasProcedimentoPeso() {
            return this.model.posConsulta.procedimentos.filter(procedimento => procedimento.codigo === this.enums.procedimento.MEDICAO_DE_PESO).length > 0
        },
        hasProcedimentoAltura() {
            return this.model.posConsulta.procedimentos.filter(procedimento => procedimento.codigo === this.enums.procedimento.MEDICAO_DE_ALTURA).length > 0
        },
        hasProcedimentoPressaoArterial() {
            return this.model.posConsulta.procedimentos.filter(procedimento => procedimento.codigo === this.enums.procedimento.AFERICAO_PRESSAO_ARTERIAL).length > 0
        },
        hasProcedimentoTemperatura() {
            return this.model.posConsulta.procedimentos.filter(procedimento => procedimento.codigo === this.enums.procedimento.AFERICAO_DE_TEMPERATURA).length > 0
        },
        hasProcedimentoGlicemiaCapilar() {
            return this.model.posConsulta.procedimentos.filter(procedimento => procedimento.codigo === this.enums.procedimento.GLICEMIA_CAPILAR).length > 0
        },
        hasProcedimento(codigo) {
            return this.model.posConsulta.procedimentos.filter(procedimento => procedimento.codigo === codigo).length > 0
        },
        insertProcedimento(codigo) {
            this.setLoading()

            this.repositories.procedimento.index({codigo})
                .then(response => {
                    const procedimento = response.data[0]

                    this.model.posConsulta.procedimentos.push({
                        id: procedimento.id,
                        codigo: procedimento.codigo,
                        nome: procedimento.nome,
                        hasInstrumentoRegistroRaas: !!procedimento.hasInstrumentoRegistroRaas,
                        automatico: true,
                        quantidade: 1,
                        localCurativo: null,
                        materialId: null,
                        materialDescricaoCompleta: null,
                        materialQuantidade: null,
                        materialEscolheuEntradaItemManualmente: null,
                        materialEntradaItens: null,
                    })
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        deleteProcedimento(codigo) {
            const index = this.model.posConsulta.procedimentos.findIndex(procedimento => procedimento.codigo === codigo)

            if (index !== -1) {
                this.model.posConsulta.procedimentos.splice(index, 1)
            }
        },
        checkCamposInvalidosParaFaturarProcedimentoRaas() {
            const camposInvalidos = []

            if (!this.form.unidade.cnes) {
                camposInvalidos.push('CNES da unidade de atendimento')
            }

            if (!this.form.paciente.nomeMae) {
                camposInvalidos.push('Nome da mãe do paciente')
            }

            if (!this.form.paciente.cep) {
                camposInvalidos.push('CEP do logradouro do paciente')
            }

            if (!this.form.paciente.ibge) {
                camposInvalidos.push('IBGE do logradouro do paciente')
            }

            if (!this.form.paciente.dataNascimento) {
                camposInvalidos.push('Data de nascimento do paciente')
            }

            if (!this.form.paciente.sexoId) {
                camposInvalidos.push('Sexo do paciente')
            }

            if (!this.form.paciente.racaCorId) {
                camposInvalidos.push('Raça/Cor do paciente')
            }

            if (!this.form.paciente.telefoneNumero) {
                camposInvalidos.push('Número do telefone do paciente')
            }

            if (camposInvalidos.length > 0) {
                let message = 'Campos inválidos para faturamento RAAS:<ul>'

                camposInvalidos.forEach(campoInvalido => {
                    message = message + `<li>${campoInvalido}</li>`
                })

                message = message + '</ul>Deseja continuar?'

                this.showWarningConfirmation('Atenção', message, async () => this.store())
            } else {
                this.store()
            }
        },
        handleAlturaChange(value) {
            if (value) {
                if (!this.hasProcedimentoAntropometria()) {
                    this.insertProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }

                if (!this.hasProcedimentoAltura()) {
                    this.insertProcedimento(this.enums.procedimento.MEDICAO_DE_ALTURA)
                }
            } else {
                const antropometria = this.model.posConsulta.antropometria

                if (!antropometria.peso && !antropometria.altura && !antropometria.perimetroCefalico && !antropometria.circunferenciaAbdominal && !antropometria.perimetroPanturrilha) {
                    this.deleteProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }

                if (!antropometria.altura) {
                    this.deleteProcedimento(this.enums.procedimento.MEDICAO_DE_ALTURA)
                }
            }
        },
        handlePerimetroCefalicoChange(value) {
            if (value) {
                if (!this.hasProcedimentoAntropometria()) {
                    this.insertProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }
            } else {
                const antropometria = this.model.posConsulta.antropometria

                if (!antropometria.peso && !antropometria.altura && !antropometria.perimetroCefalico && !antropometria.circunferenciaAbdominal && !antropometria.perimetroPanturrilha) {
                    this.deleteProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }
            }
        },
        handleCircunferenciaAbdominalChange(value) {
            if (value) {
                if (!this.hasProcedimentoAntropometria()) {
                    this.insertProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }
            } else {
                const antropometria = this.model.posConsulta.antropometria

                if (!antropometria.peso && !antropometria.altura && !antropometria.perimetroCefalico && !antropometria.circunferenciaAbdominal && !antropometria.perimetroPanturrilha) {
                    this.deleteProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }
            }
        },
        handlePerimetroPanturrilhaChange(value) {
            if (value) {
                if (!this.hasProcedimentoAntropometria()) {
                    this.insertProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }
            } else {
                const antropometria = this.model.posConsulta.antropometria

                if (!antropometria.peso && !antropometria.altura && !antropometria.perimetroCefalico && !antropometria.circunferenciaAbdominal && !antropometria.perimetroPanturrilha) {
                    this.deleteProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }
            }
        },
        handlePesoChange(value) {
            if (value) {
                if (!this.hasProcedimentoAntropometria()) {
                    this.insertProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }

                if (!this.hasProcedimentoPeso()) {
                    this.insertProcedimento(this.enums.procedimento.MEDICAO_DE_PESO)
                }
            } else {
                const antropometria = this.model.posConsulta.antropometria

                if (!antropometria.peso && !antropometria.altura && !antropometria.perimetroCefalico && !antropometria.circunferenciaAbdominal && !antropometria.perimetroPanturrilha) {
                    this.deleteProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }

                if (!antropometria.peso) {
                    this.deleteProcedimento(this.enums.procedimento.MEDICAO_DE_PESO)
                }
            }
        },
        handlePressaoArterialChange(value) {
            if (value) {
                if (!this.hasProcedimentoPressaoArterial()) {
                    this.insertProcedimento(this.enums.procedimento.AFERICAO_PRESSAO_ARTERIAL)
                }
            } else {
                this.deleteProcedimento(this.enums.procedimento.AFERICAO_PRESSAO_ARTERIAL)
            }
        },
        handleTemperaturaChange(value) {
            if (value) {
                if (!this.hasProcedimentoTemperatura()) {
                    this.insertProcedimento(this.enums.procedimento.AFERICAO_DE_TEMPERATURA)
                }
            } else {
                this.deleteProcedimento(this.enums.procedimento.AFERICAO_DE_TEMPERATURA)
            }
        },
        handleGlicemiaCapilarChange(value) {
            if (value) {
                if (!this.hasProcedimentoGlicemiaCapilar()) {
                    this.insertProcedimento(this.enums.procedimento.GLICEMIA_CAPILAR)
                }
            } else {
                this.deleteProcedimento(this.enums.procedimento.GLICEMIA_CAPILAR)
            }
        },
    },
    mixins: [error, file, permissao, repository, stringCase, unmask],
    mounted() {
        this.load()
    },
    props: {
        filaId: {type: Number, required: true},
    },
}
</script>